import RuleProvider from 'diagram-js/lib/features/rules/RuleProvider';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const HIGH_PRIORITY = 1500;
const MIN_SIZE = 20;

/**
 * Allow resize handles on all regular BPMN shapes (Tasks, Events, Gateways,
 * DataObjects, DataStores, ...) in addition to the defaults
 * (SubProcess, Participant, Lane, Group, TextAnnotation).
 *
 * Connections, labels and the root element stay non-resizable.
 */
export default class CustomResizeRules extends RuleProvider {
  init() {
    this.addRule('shape.resize', HIGH_PRIORITY, function(context) {
      const shape = context.shape;
      const newBounds = context.newBounds;

      if (!shape) return;

      // Never allow resizing connections or the root element.
      if (shape.waypoints) return false;
      if (is(shape, 'bpmn:Process') || is(shape, 'bpmn:Collaboration')) return false;

      // Defer to the default rules for already-resizable shapes whose default
      // constraints we want to keep (Participant, Lane, Group, TextAnnotation).
      if (
        is(shape, 'bpmn:Participant') ||
        is(shape, 'bpmn:Lane') ||
        is(shape, 'bpmn:Group') ||
        is(shape, 'bpmn:TextAnnotation')
      ) {
        return;
      }

      // For everything else (Tasks, Events, Gateways, DataObjects,
      // collapsed SubProcesses, labels, ...): allow, but enforce a
      // sensible minimum size when bounds are provided.
      if (newBounds && (newBounds.width < MIN_SIZE || newBounds.height < MIN_SIZE)) {
        return false;
      }

      return true;
    });
  }
}

CustomResizeRules.$inject = ['eventBus'];
